import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, Loader2, AlertTriangle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0, timer;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setState("ok"); refresh().catch(() => {}); return; }
      } catch { /* retry */ }
      if (++tries >= 15) { setState("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="max-w-lg mx-auto px-6 py-20 text-center" data-testid="payment-result">
      {state === "checking" && <><Loader2 className="w-10 h-10 text-gold animate-spin mx-auto mb-4" /><p>Stiamo confermando la tua iscrizione…</p></>}
      {state === "ok" && <>
        <CheckCircle2 className="w-12 h-12 text-gold mx-auto mb-4" />
        <h1 className="font-display text-3xl font-bold mb-2" data-testid="payment-ok">Prova gratuita attivata!</h1>
        <p className="text-slate-600 mb-6">Per 7 giorni non paghi nulla. Ora completa il profilo con foto e video.</p>
        <Link to="/dashboard" className="btn-pill-gold inline-flex">Vai alla Dashboard</Link>
      </>}
      {(state === "timeout" || state === "error") && <>
        <AlertTriangle className="w-10 h-10 text-amber-500 mx-auto mb-4" />
        <p className="mb-6">Non riusciamo ancora a confermare il pagamento. Controlla lo stato nella Dashboard tra qualche minuto.</p>
        <Link to="/dashboard" className="btn-pill-outline inline-flex">Dashboard</Link>
      </>}
    </div>
  );
}
